(() => {
  'use strict';
  const quantity = (cart, id) => cart.items.reduce((sum, item) => sum + (Number(item.variant_id) === Number(id) ? item.quantity : 0), 0);
  const total = (cart, id) => cart.items.reduce((sum, item) => sum + (Number(item.variant_id) === Number(id) ? item.final_line_price : 0), 0);
  const signature = cart => JSON.stringify(cart.items.map(item => [item.key, item.quantity]).sort());
  function choose(cart, products, config) {
    if (cart.currency !== 'GBP') return [];
    const result = [];
    const creams = ['gold', 'silver', 'platinum'];
    const hasCream = creams.some(key => products[key] && quantity(cart, products[key].id) > 0);
    const add = (key, count, kind, saving, code = '', target = 0) => {
      const p = products[key];
      if (!p || !p.available || count < 1 || (p.tracked && p.stock < count + quantity(cart, p.id))) return;
      const current = quantity(cart, p.id);
      if (kind !== 'bundle' && kind !== 'platinum' && current) return;
      if (cart.items.some(item => Number(item.variant_id) === Number(p.id) && (item.selling_plan_allocation || Object.keys(item.properties || {}).length))) return;
      result.push({key, id: p.id, product: p, count, kind, code, saving, target, before: current, price: Math.max(0, p.price * count - saving)});
    };
    if (config.bundles) {
      for (const key of ['gold', 'silver']) {
        const p = products[key];
        if (!p) continue;
        const n = quantity(cart, p.id);
        if (!n || n >= 10) continue;
        const target = n < 3 ? 3 : n < 5 ? 5 : 10;
        const saving = target === 3 ? 500 : target === 5 ? 1000 : 2500;
        const existing = Math.max(0, n * p.price - total(cart, p.id));
        if (existing >= saving) continue;
        add(key, target - n, 'bundle', saving - existing, '', target);
      }
    }
    const platinum = products.platinum;
    if (config.platinumOffer && platinum && quantity(cart, platinum.id) === 1 && products.spray && quantity(cart, products.spray.id) > 0) {
      add('platinum', 1, 'platinum', Math.floor(platinum.price / 2), config.platinumCode, 2);
    }
    if (hasCream && config.addons) {
      for (const [key, percent, code] of [['spray', 15.8, config.sprayCode], ['gel', 25.01, config.gelCode], ['balm', 40, config.balmCode]]) {
        const p = products[key];
        if (p) add(key, 1, 'addon', Math.floor(p.price * percent / 100), code);
      }
    }
    return result.slice(0, 3);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {choose, quantity, total}; return; }
  const root = document.querySelector('[data-nn-checkout-offers]');
  if (!root || root.dataset.enabled !== 'true' || !window.HTMLDialogElement) return;
  const cfg = JSON.parse(root.querySelector('[data-nn-config]').textContent);
  const dialog = root.querySelector('dialog');
  const list = root.querySelector('[data-nn-list]');
  const status = root.querySelector('[data-nn-status]');
  const continueButton = root.querySelector('[data-nn-continue]');
  const closeButton = root.querySelector('[data-nn-close]');
  const copy = cfg.copy;
  const base = window.Shopify?.routes?.root || '/';
  let cart, offers = [], bypass = false, busy = false, opening = false, resume, previousFocus, previewMode = false;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: 'GBP'}).format(cents / 100);
  async function request(path, body) {
    const response = await fetch(base + path, {credentials: 'same-origin', signal: AbortSignal.timeout(8000), headers: {'Content-Type': 'application/json', Accept: 'application/json'}, ...(body ? {method: 'POST', body: JSON.stringify(body)} : {})});
    if (!response.ok) throw new Error('cart_request_failed');
    return response.json();
  }
  function codes(c) {
    const applications = [...(c.cart_level_discount_applications || []), ...c.items.flatMap(item => (item.line_level_discount_allocations || []).map(d => d.discount_application))];
    return [...new Set([...(c.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code), ...applications.filter(d => d?.type === 'discount_code').map(d => d.title)])];
  }
  function refresh(c) { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {cart: c}})); }
  function finish() { if (busy) return; dialog.close(); if (previewMode) return; bypass = true; resume?.(); }
  function paint() {
    list.replaceChildren();
    offers.forEach((offer, index) => {
      const card = document.createElement('article');
      card.className = 'nn-checkout-offer';
      const image = document.createElement('img');
      if (offer.product.image) image.src = offer.product.image;
      image.alt = offer.product.title;
      image.width = 104; image.height = 104; image.loading = 'lazy';
      if (offer.product.image) card.append(image);
      const content = document.createElement('div');
      const title = document.createElement('h3');
      title.textContent = offer.kind === 'bundle' ? copy.bundle.replace('{count}', offer.target).replace('{name}', offer.product.title) : offer.kind === 'platinum' ? copy.platinum : offer.product.title;
      const description = document.createElement('p');
      description.textContent = offer.kind === 'bundle' ? copy.bundleDetail.replace('{count}', offer.count) : copy.addonDetail;
      const price = document.createElement('p');
      price.className = 'nn-checkout-offer__price';
      const original = document.createElement('s'); original.textContent = money(offer.product.price * offer.count);
      const current = document.createElement('strong'); current.textContent = money(offer.price);
      price.append(original, document.createTextNode(' '), current);
      const saving = document.createElement('span'); saving.className = 'nn-checkout-offer__saving'; saving.textContent = copy.save.replace('{amount}', money(offer.saving));
      const button = document.createElement('button'); button.type = 'button'; button.className = 'nn-checkout-offer__add'; button.textContent = copy.add; button.dataset.offer = String(index);
      content.append(title, description, price, saving, button); card.append(content); list.append(card);
    });
  }
  async function open(next, focus, form = null) {
    if (opening || dialog.open) return;
    opening = true;
    try {
      cart = await request('cart.js');
      previewMode = false;
      if (form) {
        const fields = new FormData(form), update = {}, updates = {};
        const quantities = fields.getAll('updates[]');
        if (quantities.length === cart.items.length) cart.items.forEach((item, i) => {
          if (/^\d+$/.test(String(quantities[i]))) updates[item.key] = Number(quantities[i]);
        });
        for (const [key, value] of fields) {
          const match = key.match(/^updates\[(.+)\]$/);
          if (match && /^\d+$/.test(String(value))) updates[match[1]] = Number(value);
          if (key === 'note') update.note = value;
          const attribute = key.match(/^attributes\[(.+)\]$/);
          if (attribute) { update.attributes ||= {}; update.attributes[attribute[1]] = value; }
        }
        if (Object.keys(updates).length) update.updates = updates;
        if (Object.keys(update).length) cart = await request('cart/update.js', update);
      }
      offers = choose(cart, cfg.products, cfg);
      if (!offers.length) { bypass = true; next(); return; }
      resume = next; previousFocus = focus; status.textContent = ''; continueButton.textContent = copy.continue; paint(); dialog.showModal();
    } catch { bypass = true; next(); }
    finally { opening = false; }
  }
  async function accept(index) {
    if (busy || previewMode) return;
    const offer = offers[index];
    if (!offer) return;
    busy = true;
    root.querySelectorAll('button').forEach(button => button.disabled = true);
    status.textContent = copy.checking;
    let before, added = false, addAttempted = false, discountAttempted = false, after;
    try {
      before = await request('cart.js');
      if (signature(before) !== signature(cart)) throw new Error('cart_changed');
      const live = await request('products/' + encodeURIComponent(offer.product.handle) + '.js');
      if (!live.variants.some(v => Number(v.id) === Number(offer.id) && v.available && Number(v.price) === offer.product.price)) throw new Error('unavailable');
      addAttempted = true;
      await request('cart/add.js', {items: [{id: offer.id, quantity: offer.count}]});
      added = true;
      if (offer.code) {
        discountAttempted = true;
        after = await request('cart/update.js', {discount: [...new Set([...codes(before), offer.code])].join(',')});
      }
      after = await request('cart.js');
      const expected = offer.product.price * (offer.before + offer.count) - (offer.kind === 'bundle' ? (offer.target === 3 ? 500 : offer.target === 5 ? 1000 : 2500) : offer.saving);
      const olderSaving = offer.kind === 'bundle' ? 0 : Math.max(0, offer.before * offer.product.price - total(before, offer.id));
      if (quantity(after, offer.id) !== offer.before + offer.count || total(after, offer.id) > expected - olderSaving + 1 || after.total_price > before.total_price + offer.price + 1 || codes(before).some(code => !codes(after).includes(code))) throw new Error('discount_not_applied');
      status.textContent = copy.added;
      list.replaceChildren();
      continueButton.textContent = copy.checkout;
      cart = after; refresh(after);
      resume = () => { window.location.href = base + 'checkout'; };
    } catch (error) {
      if (addAttempted && !added && before) {
        try { added = quantity(await request('cart.js'), offer.id) > quantity(before, offer.id); }
        catch { added = true; }
      }
      let restored = !added;
      if (added && before) {
        try {
          const latest = await request('cart.js');
          const plain = item => Number(item.variant_id) === Number(offer.id) && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
          const oldLine = before.items.find(plain);
          const newLine = latest.items.find(plain);
          if (newLine && newLine.quantity === (oldLine?.quantity || 0) + offer.count) {
            await request('cart/change.js', {id: newLine.key, quantity: oldLine?.quantity || 0});
            if (discountAttempted) await request('cart/update.js', {discount: codes(before).join(',')});
            cart = await request('cart.js'); refresh(cart); restored = signature(cart) === signature(before);
          }
        } catch { restored = false; }
      }
      status.textContent = restored ? copy.unavailable : copy.reviewCart;
      list.replaceChildren();
      if (!restored) resume = () => { window.location.href = base + 'cart'; };
      continueButton.textContent = restored ? copy.continue : copy.viewCart;
    } finally {
      busy = false;
      root.querySelectorAll('button').forEach(button => button.disabled = false);
      continueButton.focus();
    }
  }
  root.addEventListener('click', event => {
    if (event.target.closest('[data-nn-preview]')) {
      previewMode = true; previousFocus = event.target; resume = null;
      const p = cfg.previewProducts;
      offers = choose({currency:'GBP',items:[{variant_id:p.gold.id,quantity:1,final_line_price:p.gold.price,properties:{}}]}, p, cfg);
      status.textContent = copy.preview; continueButton.textContent = copy.closePreview; paint();
      list.querySelectorAll('button').forEach(button => button.disabled = true);
      dialog.showModal(); return;
    }
    const add = event.target.closest('[data-offer]');
    if (add) accept(Number(add.dataset.offer));
  });
  continueButton.addEventListener('click', finish);
  closeButton.addEventListener('click', finish);
  dialog.addEventListener('cancel', event => { event.preventDefault(); finish(); });
  dialog.addEventListener('close', () => previousFocus?.focus());
  document.addEventListener('click', event => {
    if (bypass) return;
    const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
    if (!button || root.contains(button) || button.disabled || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (button.matches('a')) {
      const url = new URL(button.href, location.origin);
      if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault(); event.stopImmediatePropagation(); open(() => { location.href = url.href; }, button);
    } else {
      const form = button.form;
      if (!form || !/\/cart\/?$/.test(new URL(form.action, location.origin).pathname) || !form.reportValidity()) return;
      event.preventDefault(); event.stopImmediatePropagation(); open(() => { location.href = base + 'checkout'; }, button, form);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (bypass || event.submitter?.name !== 'checkout') return;
    const form = event.target, submitter = event.submitter;
    if (!/\/cart\/?$/.test(new URL(form.action, location.origin).pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    open(() => { location.href = base + 'checkout'; }, submitter, form);
  }, true);
})();
